import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import { getToken } from '@versita/frontend/auth-web';
import environment from '../environments/environment';

export const studentPortalApiBase = createApi({
  reducerPath: 'studentPortalApi',
  tagTypes: ['Course'],
  baseQuery: retry(
    fetchBaseQuery({
      baseUrl: environment.apis.studentPortalApi.endpoint,
      // isJsonContentType: () => false,
      // paramsSerializer: (params) => {
      //   params['x-ms-routing-name'] = 'inactive';
      //   return new URLSearchParams(params).toString();
      // },
      prepareHeaders: async (headers, api) => {
        const accessToken = await getToken();
        if (accessToken) {
          headers.set('Authorization', `Bearer ${accessToken}`);
        }
        return headers;
      },
    }),
    { maxRetries: 1 },
  ),
  endpoints: () => ({}),
});
